import PropTypes from 'prop-types'
import React from 'react'
import { formatPriceEnding } from '../../../../../../functions'
import config from 'SRC/config/config.yaml'

export const Price = ({packages}) => {
  const text = config.registrationForm.package.price
  return <tr>
    <td><strong>{text}</strong></td>
    {
      packages.map(item => <td key={item.id}>{formatPriceEnding(item.price)}</td>)
    }
  </tr>
}
Price.propTypes = {
  packages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    price: PropTypes.number
  })).isRequired
}

Price.defaultProps = {
  packages: []
}
